import { formatDistanceToNow as fnsFormatDistanceToNow } from 'date-fns';

import locales from 'src/constants/locales';

const formatDistanceToNow = (
    timeStamp: string,
    lang: SupportedLangs,
    addSuffix = false,
    showApproximationPrefix = true,
) => {
    let text = fnsFormatDistanceToNow(new Date(timeStamp), {
        locale: locales[lang],
        addSuffix,
    });

    if (!showApproximationPrefix) {
        text = text
            .replace('about ', '')
            .replace('environ ', '')
            .replace('less than a minute', '1 minute')
            .replace("moins d'une minute", '1 minute');
    }

    return text;
};

export default formatDistanceToNow;
